import axios from 'axios';
import { call } from 'redux-saga/effects';
import { BOX_OFFICE_MOVIES_ENDPOINT, BOX_OFFICE_PERIOD_ENDPOINT, BOX_OFFICE_MOVIES_HOME_ENDPOINT, BOX_OFFICE_DISTRIBUTORS_ENDPOINT, BOX_OFFICE_STUDIOS_ENDPOINT } from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getMoviesFropAPI(payload) {
    const header = tokenHeader();

    let url = '';
    if (payload.genres.length > 0) {
        url =  BOX_OFFICE_MOVIES_ENDPOINT + `${payload.startDate}?box_office_genre_target_id=${payload.genres[0]}`;
    }
    else{
        url = BOX_OFFICE_MOVIES_ENDPOINT + `${payload.startDate}`;
    }
    return yield call(axios.get, url, header);
}

export function* getBoxOfficeHome(payload) {
    const header = tokenHeader();

    return yield call(axios.get, BOX_OFFICE_MOVIES_HOME_ENDPOINT, header);
}

export function* getDatesForBoxOffice(payload) {
    const header = tokenHeader();
    return yield call(axios.get, BOX_OFFICE_PERIOD_ENDPOINT, header);
}

export function* getBoxOfficeDistributors(payload) {
    const header = tokenHeader();

    let api_url_dynamic = BOX_OFFICE_DISTRIBUTORS_ENDPOINT.replace('date', payload.startDate);
    return yield call(axios.get, api_url_dynamic, header);
}

export function* getBoxOfficeStudios(payload) {
    const header = tokenHeader();
    let api_url_dynamic = BOX_OFFICE_STUDIOS_ENDPOINT.replace('date', payload.startDate);
    return yield call(axios.get, api_url_dynamic, header);
}




// WEBPACK FOOTER //
// ./src/SHARED/api/boxoffice.api.js